import { SITE, whatsappUrl } from "@/config/site";
import { AccessLink } from "@/components/AccessLink";
import SectionHeading from "@/components/SectionHeading";
import { WhatsAppIcon } from "@/components/icons";

export default function ContactSection() {
  const wa = whatsappUrl();

  return (
    <section id="contato" className="relative scroll-mt-20 overflow-hidden py-28 sm:py-32" data-testid="contact-section">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[460px] w-[460px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand-teal/15 blur-[130px]" aria-hidden="true" />

      <div className="relative mx-auto max-w-3xl px-5 text-center sm:px-8">
        <SectionHeading
          align="center"
          eyebrow="Contato"
          title="Vamos dar o primeiro passo?"
          sub="Entre em contato para conhecer as opções de acompanhamento e encontrar a melhor forma de começar."
          testId="contact-heading"
        />

        <AccessLink
          href={wa}
          external
          testId="contact-section-whatsapp-btn"
          badgeClassName="mt-4 sm:ml-3 border-slate-900/20 bg-slate-950/10 text-slate-900"
          className="mt-10 inline-flex flex-col items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-brand-tealight to-brand-blue px-9 py-4 text-lg font-bold text-slate-950 shadow-[0_0_28px_rgba(94,155,150,0.35)] transition-all hover:scale-[1.02] hover:shadow-[0_0_40px_rgba(94,155,150,0.55)] active:scale-[0.98] sm:flex-row aria-disabled:opacity-60 aria-disabled:shadow-none aria-disabled:hover:scale-100"
        >
          <WhatsAppIcon className="h-5 w-5" />
          Conversar no WhatsApp
        </AccessLink>

        <p className="mt-9 font-mono text-xs uppercase tracking-[0.22em] text-slate-500">
          {SITE.trainerName} — {SITE.cref}
        </p>
      </div>
    </section>
  );
}
